import React from 'react';
import { AlertTriangle, X } from 'lucide-react';
import './ConfirmModal.css';

export default function ConfirmModal({
  isOpen,
  title = 'Are you sure?',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  variant = 'default',
  onConfirm,
  onCancel,
}) {
  if (!isOpen) return null;

  return (
    <div
      className="confirmModal__backdrop"
      onClick={onCancel}
      role="presentation"
    >
      <div
        className="confirmModal"
        onClick={(e) => e.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <button
          className="confirmModal__close"
          onClick={onCancel}
          aria-label="Close"
        >
          <X size={18} />
        </button>

        {variant === 'danger' && (
          <div className="confirmModal__iconWrap">
            <AlertTriangle size={28} />
          </div>
        )}

        <h3 className="confirmModal__title">{title}</h3>
        {message && <p className="confirmModal__message">{message}</p>}

        <div className="confirmModal__actions">
          <button
            type="button"
            className="confirmModal__cancel"
            onClick={onCancel}
          >
            {cancelLabel}
          </button>
          <button
            type="button"
            className={`confirmModal__confirm confirmModal__confirm--${variant}`}
            onClick={onConfirm}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
